import { gql } from '@apollo/client';

export const ADD_USER_TO_NO_LIMIT_GROUP = gql`
  mutation AddUserToNoLimitGroup($customerId: String!) {
    addUserToNoLimitGroup(input: { customerId: $customerId }) {
      status
      message
      requestId
    }
  }
`;
